import { windowWidth, windowHeight } from "../layout";
// components
import '../components/banner.js';
// gsap
import { gsap } from "../layout";